import { render, staticRenderFns } from "./produkkredit.vue?vue&type=template&id=b37d50e2&scoped=true"
import script from "./produkkredit.vue?vue&type=script&lang=js"
export * from "./produkkredit.vue?vue&type=script&lang=js"
import style0 from "./produkkredit.vue?vue&type=style&index=0&id=b37d50e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37d50e2",
  null
  
)

export default component.exports